import React from 'react'
import HospitalHome from '../../components/HospitalHome/HospitalHome'

function HospitalHomePage() {
  return (
    <HospitalHome/>
  )
}

export default HospitalHomePage